window.addEventListener('load', function() {
    const termColors = {
        'vídeos': '#091D5A',
        'séries': '#666666',
        'fotografias': '#588758'
    };

    console.log('Applying term colors to collection items...');

    function applyTermColors() {
        document.querySelectorAll('.wp-block-post').forEach(function(item) {
            const linkEl = item.querySelector('.wp-block-post-title a');
            if (!linkEl) return;

            const linkText = linkEl.textContent.toLowerCase().trim();

            Object.keys(termColors).forEach(function(term) {
                if (linkText === term.toLowerCase()) {
                    const titleEl = item.querySelector('.wp-block-post-title');
                    if (titleEl) {
                        titleEl.style.cssText = 'background-color: ' + termColors[term] + '; color: #fff; padding: 8px 16px; border-radius: 6px; display: inline-block;';
                    }
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(applyTermColors, 1000);
        });
    } else {
        setTimeout(applyTermColors, 1000);
    }
});
